'use client';

import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import Select from '../molecules/select';

export default function SortOptions({
  sort,
}: {
  sort: string;
}) {
  const router = useRouter();

  const pathname = usePathname();
  const searchParams = useSearchParams();

  const sortSearchParams = new URLSearchParams(searchParams);

  return (
    <Select label='Sort' value={sort} onChange={(e) => {
      sortSearchParams.set('sort', e.target.value);
      router.push(`${pathname}?${sortSearchParams}`);
    }}>
      <option>A-Z</option>
      <option>Scripture</option>
      <option>Recently Added</option>
    </Select>
  );
}
